import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { updateRefreshTimeStamp } from 'features/ui/uiSlice'
import { useRefreshInfo } from 'hooks/useUiState/index'

const useAutoRefreshTimer = () => {
  const dispatch = useAppDispatch()
  const refreshInfo = useRefreshInfo()

  useEffect(() => {
    const interval = setInterval(() => {
      if (refreshInfo.enabled) {
        dispatch(updateRefreshTimeStamp())
      }
    }, refreshInfo.interval)

    return () => clearInterval(interval)
  }, [refreshInfo.interval, dispatch, refreshInfo.enabled])
}

export default useAutoRefreshTimer
